import '../App.css';
import React, { useEffect } from 'react'
import NavBar from '../Widgets/NavBar';
import Footer from '../Widgets/Footer';

export default function FinalProject() {
    useEffect(() =>{
        document.title = "Projetos"
    }, [])
    return (
        <div className='page-wrapper'>
            <header className="py-5">
                <div className="container">
                    <div className="row">
                        <NavBar selected='projects-page'></NavBar>
                    </div>
                </div>
            </header>

            <section id="about" className="py-3">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="section-title">Still Building...</h2>

                        </div>
                    </div>
                </div>
            </section>


            <Footer></Footer>
        </div>
    )
}
